module.exports = __webpack_public_path__ + "img/alentour28.a663e4f9.jpg";